import { delegateEvent, triggerEvent } from 'utilities/dom';
import {
	trackFullScreenImage,
	sendVideoAnalytics,
	trackVideoDismiss,
	trackVideoPlayback,
	trackVideoThumbnailClick,
	utagLinkPDP,
	utagLinkPLA
} from 'features/tealium';
import { setGenericEvent } from 'features/tealium/ga4/custom';

(() => {

	const pla = document.querySelector('#qlBkg');
	const trackGAEvents = pla ? utagLinkPLA() : utagLinkPDP();
	const youtubeNoCookieHost = 'https://www.youtube-nocookie.com';
	const { page_type, product_category: productCategory = [] } = window.utag_data;
	const isPlaPage = page_type === 'sfp_full' || page_type === 'sfp_partial';
	const isPdpPage = page_type === 'product';
	const [ primaryCategory ] = productCategory;
	const { shortSku } = window;

	const fireGA4Event = (eventName, eventdata) => {
		setGenericEvent({
			event_name: eventName,
			...(isPdpPage && { pdp_item_id: shortSku, pdp_prime_cat: primaryCategory }),
			...(isPlaPage && { sfp_item_id: shortSku, sfp_prime_cat: primaryCategory }),
			...eventdata,
		});
	};

	let fsVideoPlayer = null; 

	class FullScreen {

		constructor ({
			imageCount, isVideo, image, shortSku, srcDelimiter = '?', trackCustomerEvent = false
		}) {

			this.image = image;
			this.imageCount = imageCount;
			this.hasModalVideos = true;
			this.isVideo = isVideo;
			this.isImage = false;
			this.shortSku = shortSku;
			this.srcDelimiter = srcDelimiter;
			this.trackCustomerEvent = trackCustomerEvent;

			this.fsVideoPlayerDiv = null;
			this.fsVideoContainer = null;
			this.largeImage = null;
			this.largeImageWidth = null;
			this.largeImageHeight = null;
			this.largeImageInitialHeight = null;
			this.largeImageInitialWidth = null;
			this.largeImageLastWidth = null;
			this.largeImageLastHeight = null;

			this.originalImageHeight = null;
			this.originalImageWidth = null;

			// zoom
			this.zoomCounter = 1;
			this.scaleConstant = null;
			this.scaleProduct = 1;
			this.zoomCounterMax = null;
			this.isZooming = false;

			// image drag
			this.isDragging = null;
			this.lastXAxisOfImage = null;
			this.lastYAxisOfImage = null;

			// image click
			this.clickImage = true;
			this.isZoomingIn = true;

			this.dragImageStartDelegate = null;
			this.moveImageDelegate = null;
			this.clickImageDelegate = null;
			this.zoomHandlerListener = null;
			this.fsNavHandlerListener = null;

			// bind functions to this
			this.onTransitionEnd = this.onTransitionEnd.bind(this);
			this.dragImageStartHandler = this.dragImageStartHandler.bind(this);
			this.moveImageHandler = this.moveImageHandler.bind(this);
			this.clickImageHandler = this.clickImageHandler.bind(this);
			this.fsLoadHandler = this.fsLoadHandler.bind(this);
			this.setVideoPlayerDimensions = this.setVideoPlayerDimensions.bind(this);
			this.videoDismissOnUnmount = this.videoDismissOnUnmount.bind(this);

		}

		setFullscreenElements () {

			this.prevImageModal = document.getElementById('prevImageModal');
			this.nextImageModal = document.getElementById('nextImageModal');
			const contentWrapper = document.getElementById('fsContent') || document.getElementById('lpModalContent');
			this.initialContentHeight = contentWrapper.clientHeight;
			this.initialContentWidth = contentWrapper.clientWidth;

			this.contentHeight = this.initialContentHeight;
			this.fsContent = document.getElementById('fsContent');
			this.shopThisRoomBtn = document.getElementById('shopThisRoomBtn');
			this.fsImageContainer = document.getElementById('fsImageContainer');
			this.fsVideoContainer = document.getElementById('fsVideoContainer');
			this.fsVideoPlayerDiv = document.getElementById('fsVideoPlayer');
			this.fsZoomOptions = document.getElementById('fsZoomOptions');
			this.fsZoomIn = document.getElementById('fsZoomIn');
			this.fsZoomOut = document.getElementById('fsZoomOut');
			this.fsZoomReset = document.getElementById('fsReset');
			this.fsLoader = document.getElementById('fsWrapper').querySelector('.loader');

		}

		changeFsContentDimensions (width, height) {

			this.contentWidth = width;
			if (height) {

				this.contentHeight = height;

			}

		}

		hideVideoPlayer () {

			if (this.fsVideoPlayerDiv) {

				// fsvideoplayerdiv is not referencing iframe on subsequent opening of modal
				this.fsVideoPlayerDiv = document.getElementById('fsVideoPlayer');
				this.fsVideoPlayerDiv.classList.remove('withVideo');
				this.fsVideoPlayerDiv.classList.add('hidden');

			}

		}

		hideImage () {

			this.fsImageContainer.innerHTML = '';
			this.fsImageContainer.classList.add('hidden');

		}
		hideVideoContainer () {
			if(this.fsVideoContainer){
				this.fsVideoContainer.innerHTML = '';
				this.fsVideoContainer.classList.add('hidden');
			}
		}

		getCommonFsContentWidth () {

			// no need to do computation as its width is automaticaly adjusted via CSS
			return this.fsContent.offsetWidth;

		}

		fsNavClickHandler (thumbnail) {
			window.clearInterval(window.lp.videoPlaybackInterval);
			// if thumbnail is already selected, do nothing
			if (thumbnail.classList.contains('selectedThumbnail')) {

				return;

			}

			const image = thumbnail.querySelector('img');
			this.image = image
			const imagePath = image ? image.dataset.imgpath : null;
			const newContentWidth = this.getCommonFsContentWidth();

			const a = document.createElement('a');
			a.href = image.src;

			this.fsLoader.classList.remove('hidden');
			thumbnail.classList.add('active');

			const { videoid, videoHeadline, contentType, sourceUrl } = image.dataset;
			if (videoid !== '' || contentType === 'video') {
				
				window.lp.video.activeVideoHeadline = videoHeadline || "";
				
				this.isImage = false;
				this.isVideo = true;
				this.loadVideo(videoid, sourceUrl);

				trackVideoThumbnailClick(videoid, { fromModal: true });

			} else {

				const sku = window.utag_data.product_sku[0];

				if (sku && imagePath) {

					trackFullScreenImage(sku, imagePath);

				}
				this.htmlVideoPlayer?.pause();
				if (fsVideoPlayer?.stopVideo !== undefined) {

					fsVideoPlayer.stopVideo();

					trackVideoDismiss(fsVideoPlayer)
						.then((trackingData) => {
		
							if (trackingData) {
		
								sendVideoAnalytics(trackingData);
		
							}
		
						})
						.catch((err) => {
		
							console.error(err);
		
						});

				}

				this.isImage = true;
				this.isVideo = false;

				this.clickImage = true;
				this.isZoomingIn = true;

				this.zoomCounter = 1;
			}

			const fsNav = document.getElementById('fsNav');
			fsNav.querySelectorAll('.thumbnailWrapper').forEach((el) => {

				el.classList.remove('selectedThumbnail');

			});

			fsNav
				.querySelector(`.thumbnailWrapper img[src*="${a.pathname}"]`)
				.parentNode.classList.add('selectedThumbnail');

			this.changeFsContentDimensions(newContentWidth);

			if (!this.isVideo) {

				this.displayFullImage(image);
				return;

			}

			this.displayZoomControls();
			this.setImageDraggableStatus();

		}

		fsZoomInHandler () {

			if (this.isZooming || this.zoomCounter === 0 || this.zoomCounterMax === 0) {

				return;

			}
			if(this.trackCustomerEvent) {
				trackGAEvents({
					eventAction: 'Zoom-In-Customer-Photo',
					eventLabel: `${window.shortSku}-Customer Image ${+this.image.dataset.index + 1}`,
				});
			} else {
				trackGAEvents({
					eventAction: 'Zoom-In-Image-Modal',
					eventLabel: `${window.shortSku}-${this.largeImage.dataset.imgpath}`
				});
			}
			if (isPdpPage || isPlaPage) {
				const imgFileName = this.trackCustomerEvent
					? `Customer Image ${+this.image.dataset.index + 1}`
					: this.largeImage.dataset.imgpath;
				fireGA4Event(isPdpPage ? 'pdp_img_zmin' : 'sfp_img_zmin', { img_file_name: imgFileName });
			}

			this.largeImage.classList.add('withTransition');
			this.largeImage.style.transform = `scale(${this.scaleConstant})`;
			this.largeImageWidth = this.largeImageWidth || this.largeImage.width;
			this.largeImageHeight = this.largeImageHeight || this.largeImage.height;
			this.largeImageWidth = Math.round(this.largeImageWidth * this.scaleConstant);
			this.largeImageHeight = Math.round(this.largeImageHeight * this.scaleConstant);
			// increase zoom counter
			this.zoomCounter += 1;
			this.isZooming = true;
			this.scaleProduct *= this.scaleConstant;

			if (this.zoomCounter < this.zoomCounterMax) {

				this.isZoomingIn = true;

			} else if (this.zoomCounter >= this.zoomCounterMax) {

				this.isZoomingIn = false;

			}

		}

		fsZoomOutHandler () {

			if (this.isZooming || this.zoomCounter === 0 || this.zoomCounterMax === 0) {

				return;

			}
			if(this.trackCustomerEvent) {
				trackGAEvents({
					eventAction: 'Zoom-Out-Customer-Photo',
					eventLabel: `${window.shortSku}-Customer Image ${+this.image.dataset.index + 1}`,
				});
			} else {
				trackGAEvents({
					eventAction: 'Zoom-Out-Image-Modal',
					eventLabel: `${window.shortSku}-${this.largeImage.dataset.imgpath}`
				});
			}
			if (isPdpPage || isPlaPage) {
				const imgFileName = this.trackCustomerEvent
					? `Customer Image ${+this.image.dataset.index + 1}`
					: this.largeImage.dataset.imgpath;
				fireGA4Event(isPdpPage ? 'pdp_img_zmout' : 'sfp_img_zmout', { img_file_name: imgFileName });
			}
			// decrease zoom counter
			this.zoomCounter -= 1;

			if (this.zoomCounter === 1) {

				// skip zoom reset tracking
				this.fsZoomResetHandler({ skipTracking: true });
				return;

			}
			this.largeImage.classList.add('withTransition');
			this.largeImage.style.transform = `scale(${1 / this.scaleConstant})`;
			this.largeImageWidth = Math.round(this.largeImageWidth / this.scaleConstant);
			this.largeImageHeight = Math.round(this.largeImageHeight / this.scaleConstant);

			this.isZooming = true;
			this.scaleProduct /= this.scaleConstant;

			if (this.zoomCounter < this.zoomCounterMax) {

				this.isZoomingIn = false;

			}

		}

		fsZoomResetHandler ({ skipTracking = false } = {}) {

			if (this.isZooming) {

				return;

			}

			// don't track if not triggered directly (example: triggered from fsZoomOutHandler method)
			if (!skipTracking) {

				trackGAEvents({
					eventAction: 'Click-Start-Over-Image-Modal',
					eventLabel: `${window.shortSku}-${this.largeImage.dataset.imgpath}`
				});

			}

			this.largeImage.classList.add('withTransition');
			this.fsImageContainer.classList.add('withTransition');
			this.largeImage.style.transform = `scale(${1 / this.scaleProduct})`;
			this.centerImage(this.largeImageWidth, this.largeImageHeight, true);
			this.zoomCounter = 1;
			this.largeImageWidth = this.largeImageInitialWidth;
			this.largeImageHeight = this.largeImageInitialHeight;
			this.isZooming = true;
			this.scaleProduct = 1;
			this.isZoomingIn = true;

		}

		onTransitionEnd () {

			this.largeImage.removeAttribute('style');
			this.largeImage.classList.remove('withTransition');
			this.fsImageContainer.classList.remove('withTransition');
			this.largeImage.height = this.largeImageHeight;
			this.largeImage.width = this.largeImageWidth;
			this.centerImage(this.largeImageWidth, this.largeImageHeight);
			this.largeImage.src = this.largeImage.src
				.replace(/wid=[0-9]+/, `wid=${this.largeImageWidth}`)
				.replace(/hei=[0-9]+/, `hei=${this.largeImageHeight}`);
			this.fsImageContainer.style.width = `${this.largeImageWidth}px`;
			this.scaleConstant = this.getScaleConstant(this.largeImageHeight);
			this.displayZoomControls();
			this.setImageDraggableStatus();

		}

		centerImage (imageX, imageY, forceCenter = false) {

			// get the size of the container
			const containerX = this.getCommonFsContentWidth();
			const containerY = this.fsContent.clientHeight;

			const containerLeft = parseInt(this.fsImageContainer.style.left, 10);
			const containerTop = parseInt(this.fsImageContainer.style.top, 10);
			const imageDelta = {};
			if (typeof containerLeft === 'number' && typeof containerTop === 'number' && !forceCenter) {

				imageDelta.height = (imageY - this.largeImageLastHeight) / 2;
				imageDelta.width = (imageX - this.largeImageLastWidth) / 2;
				this.fsImageContainer.style.left = `${Math.round(containerLeft - imageDelta.width)}px`;
				this.fsImageContainer.style.top = `${Math.round(containerTop - imageDelta.height)}px`;

			} else {

				this.fsImageContainer.style.left = `${Math.round((containerX - imageX) / 2)}px`;
				this.fsImageContainer.style.top = `${Math.round((containerY - imageY) / 2)}px`;

			}

			this.largeImageLastWidth = imageX;
			this.largeImageLastHeight = imageY;

		}

		displayFullImage (image) {

			// create a reference to the class :(
			const that = this;
			const imagePath = image.dataset.imgpath;
			const imageServerUrl = image.dataset.imgserverurl;
			const customColor = window.lp?.pdp?.productJsonModel ? lp.pdp.productJsonModel.OriginalPattern : null;
			const { color, caption } = image.dataset;
			const originalImage = new Image();

			let imgSrc;

			this.changeFsContentDimensions(this.getCommonFsContentWidth());

			if (color || customColor) {

				// image with patterns (customized products)
				imgSrc = `${image.src
					.replace(/(\?|\&)wid=[0-9]+/, '')
					.replace(/(\?|\&)hei=[0-9]+/, '')}${this.getFullImageQuery(
					this.contentHeight,
					this.contentWidth,
					'&'
				)}`;

			} else if(!imageServerUrl) {
				imgSrc = `${imagePath}${this.getFullImageQuery(
					this.contentHeight,
					this.contentWidth
				)}`;
			} else {

				imgSrc = `${imageServerUrl}${imagePath}.jpg${this.getFullImageQuery(
					this.contentHeight,
					this.contentWidth
				)}`;

			}

			// reset some variables
			this.scaleProduct = 1;
			this.zoomCounter = 1;
			this.fsImageContainer.style.left = 0;
			this.fsImageContainer.style.top = 0;
			this.fsImageContainer.style.width = null;
			this.originalImageHeight = null;
			this.originalImageWidth = null;
			this.largeImageWidth = null;
			this.largeImageHeight = null;
			this.largeImageInitialHeight = null;
			this.largeImageInitialWidth = null;
			this.scaleConstant = null;
			this.zoomCounterMax = null;
			const fsPhotoTitle =  document.querySelector(".fsPhotoTitle");
			if(fsPhotoTitle) fsPhotoTitle.innerHTML = caption || "";

			originalImage.onload = function () {

				that.originalImageHeight = this.height;
				that.originalImageWidth = this.width;
				that.imagesLoaded();

			};

			originalImage.src = color
				? `https://image.lampsplus.com/is/image/images/?src=ir(images/${imagePath})`
				: imageServerUrl ? image.src.split(this.srcDelimiter)[0] : imagePath;

			if (this.hasModalVideos) {

				this.hideVideoPlayer();

			}
			this.hideVideoContainer()

			this.fsImageContainer.classList.remove('hidden');
			this.fsImageContainer.innerHTML = '';

			this.largeImage = document.createElement('img');
			this.largeImage.src = imgSrc;
			this.largeImage.dataset.imgpath = imagePath;

			this.largeImage.alt = image.alt?.replace('&quot;', '"') || '';
			this.largeImage.id = 'largePic';
			this.largeImage.classList.add('hidden');
			this.fsImageContainer.appendChild(this.largeImage);

			this.largeImage.removeEventListener('transitionend', this.onTransitionEnd);
			this.largeImage.removeEventListener('load', this.fsLoadHandler);
			this.largeImage.addEventListener('transitionend', this.onTransitionEnd);
			this.largeImage.addEventListener('load', this.fsLoadHandler);

		}

		getFullImageQuery (height, width, delimiter = '?') {

			if (height && width) {

				return `${delimiter}qlt=65&wid=${width}&hei=${height}&fit=constrain&fmt=jpeg`;

			}
			return `${delimiter}qlt=65&hei=${height}&fit=constrain&fmt=jpeg`;

		}

		initVideoPlayer () {

			fsVideoPlayer = new window.YT.Player('fsVideoPlayer', {
				playerVars: window.lp.video.youtube.apiSettings,
				host: youtubeNoCookieHost,
				events: {
					onReady: () => {

						// on full screen init, capture video id and headline when player is about to start
						window.lp.video.activeVideoHeadline = this.image.dataset.videoHeadline;
						const { videoid, sourceUrl } = this.image.dataset;
						this.loadVideo(videoid, sourceUrl);
						trackVideoPlayback(fsVideoPlayer, { id: videoid });

					}
				}
			});

		}

		loadVideo(videoid, sourceUrl) {
			if(videoid) this.loadYTVideo(videoid);
			else if(sourceUrl) this.loadVideoWithURL(sourceUrl);
		}

		loadVideoWithURL(sourceUrl){
			if(!this.isVideo) return;
			this.displayZoomControls();
			this.setImageDraggableStatus();
			this.hideImage();
			this.hideVideoPlayer();
			this.fsVideoContainer.classList.remove('hidden');
			this.fsVideoContainer.innerHTML = '';
			this.htmlVideoPlayer = document.createElement('video');
			this.htmlVideoPlayer.src = sourceUrl;
			this.htmlVideoPlayer.setAttribute("controls","controls")
			this.htmlVideoPlayer.poster = this.image.src
			this.fsVideoContainer.appendChild(this.htmlVideoPlayer);
			const loadHtmlVideoPlayer = ()=>{
				this.htmlVideoPlayer.play();
			}
			this.htmlVideoPlayer.removeEventListener('loadeddata', loadHtmlVideoPlayer);
			this.htmlVideoPlayer.addEventListener('loadeddata', loadHtmlVideoPlayer);

		}

		loadYTVideo (videoid) {
			let isVideoReady;
			let relaunchVideo;

			const launchPlayer = () => {

				clearInterval(isVideoReady);

				const launch = () => {

					clearInterval(relaunchVideo);

					if (typeof fsVideoPlayer.loadVideoById === 'undefined') {

						window.onYouTubeIframeAPIReady = function () {

							fsVideoPlayer.loadVideoById(videoid);

						};

					} else {

						fsVideoPlayer.loadVideoById(videoid);

					}

				};

				launch();

				// relaunch the player if it is stuck
				relaunchVideo = setInterval(() => {

					if (
						fsVideoPlayer?.getPlayerState() === -1
					) {

						launch();

					}

				}, 500);

			};

			// note the container originally is a DIV before being converted to an iFrame by YouTube
			if (this.fsVideoPlayerDiv.tagName === 'DIV') {

				this.fsVideoPlayerDiv = document.getElementById('fsVideoPlayer');
				this.fsVideoPlayerDiv.addEventListener('load', this.setVideoPlayerDimensions);

			}

			if (!this.isVideo) {

				return;

			}

			this.displayZoomControls();
			this.setImageDraggableStatus();
			this.hideImage();
			this.hideVideoContainer();

			this.fsVideoPlayerDiv.classList.remove('hidden');
			this.fsVideoPlayerDiv.classList.add('withVideo');

			// check if YT was fully loaded
			isVideoReady = setInterval(() => {

				if (fsVideoPlayer?.getPlayerState) {

					launchPlayer();

				}

			}, 500);

		}

		initFsNav () {

			const fsNav = document.getElementById('fsNav');

			if (this.imageCount > 0) {

				fsNav.classList.remove('hidden');
				fsNav.addEventListener('click', this.fsNavHandlerListener);

			} else {

				fsNav.classList.add('hidden');

			}

		}

		setVideoPlayerDimensions () {

			fsVideoPlayer = fsVideoPlayer.setSize(
				Math.round(this.contentHeight / window.lp.video.youtube.aspectRatio),
				this.contentHeight
			);

		}

		disableZoomButton (element) {
			element.classList.add('disabled');
			element.ariaDisabled = true;
		}

		enableZoomButton (element) {
			element.classList.remove('disabled');
			element.ariaDisabled = false;
		}

		displayZoomControls () {

			if (this.isVideo || this.zoomCounter === 0 || this.zoomCounterMax === 0) {

				this.fsZoomOptions.classList.add('invisible');

			} else {

				this.fsZoomOptions.classList.remove('invisible');

			}

			if (this.zoomCounter === 1) {
				this.enableZoomButton(this.fsZoomIn);
				this.disableZoomButton(this.fsZoomOut);
				this.disableZoomButton(this.fsZoomReset);
			} else if (this.zoomCounter < this.zoomCounterMax) {
				this.enableZoomButton(this.fsZoomIn);
				this.enableZoomButton(this.fsZoomOut);
				this.enableZoomButton(this.fsZoomReset);
			} else if (this.zoomCounter >= this.zoomCounterMax) {
				this.disableZoomButton(this.fsZoomIn);
				this.enableZoomButton(this.fsZoomOut);
				this.enableZoomButton(this.fsZoomReset);
			}

		}

		setImageDraggableStatus () {

			if (this.isVideo || this.zoomCounter <= 1) {

				this.fsImageContainer.classList.remove('fsImageContainer--draggable');
				return;

			}

			this.fsImageContainer.classList.add('fsImageContainer--draggable');

		}

		initZoomControls () {

			const zoomControls = this.fsZoomOptions.querySelectorAll('.zoomControl');
			zoomControls.forEach((control) => {

				control.addEventListener('click', this.zoomHandlerListener);

			});

		}

		initDragControls () {

			const selector = `#${this.fsImageContainer.id}`;
			this.isDragging = false;
			this.lastXAxisOfImage = 0;
			this.lastYAxisOfImage = 0;

			this.fsContent.addEventListener('mousedown', this.dragImageStartDelegate);
			this.fsContent.addEventListener('touchstart', this.dragImageStartDelegate);

			this.fsContent.addEventListener('mousemove', this.moveImageDelegate);
			this.fsContent.addEventListener('touchmove', this.moveImageDelegate);

			this.fsContent.addEventListener('mouseup', this.clickImageDelegate);
			this.fsContent.addEventListener('mouseout', this.clickImageDelegate);

			this.fsContent.addEventListener(
				'touchend',
				delegateEvent(() => {

					this.isDragging = false;

					// remove page scroll prevention
					document.removeEventListener('touchmove', this.preventDefault, { passive: false });
					document.body.style.overflow = '';

				}, selector)
			);

		}

		preventDefault (e) {

			e.preventDefault();

		}

		dragImageStartHandler (e) {

			this.clickImage = true;

			if (this.zoomCounter === 1) {

				return false;

			}
			if(!this.trackCustomerEvent) {

				trackGAEvents({
					eventAction: 'Zoomed-Drag-Image-Modal',
					eventLabel: `${window.shortSku}-${this.largeImage.dataset.imgpath}`
				});

			}

			if (isPdpPage || isPlaPage) {
				const imgFileName = this.trackCustomerEvent
					? `Customer Image ${+this.image.dataset.index + 1}`
					: this.largeImage.dataset.imgpath;
				fireGA4Event(isPdpPage ? 'pdp_img_zmdrag' : 'sfp_img_zmdrag', {
					img_file_name: imgFileName,
				});
			}

			const clientX = e.clientX || e.changedTouches[0].clientX;
			const clientY = e.clientY || e.changedTouches[0].clientY;

			this.lastXAxisOfImage = clientX - this.fsImageContainer.offsetLeft;
			this.lastYAxisOfImage = clientY - this.fsImageContainer.offsetTop;
			this.isDragging = true;

			// prevent touch devices to scroll page while dragging the image
			document.addEventListener('touchmove', this.preventDefault, { passive: false });
			if (e.type === 'touchstart') {

				document.body.style.overflow = 'hidden';

			}

			return true;

		}

		moveImageHandler (e) {

			this.clickImage = false;

			if (!this.isDragging) {

				return;

			}

			const clientX = e.clientX || e.changedTouches[0].clientX;
			const clientY = e.clientY || e.changedTouches[0].clientY;

			const containerWidth = this.fsContent.clientWidth;
			const containerHeight = this.fsContent.clientHeight;

			const imageWidth = this.largeImage.clientWidth || this.largeImageWidth;
			const imageHeight = this.largeImage.clientHeight || this.largeImageHeight;

			const maxtop = containerHeight - imageHeight;
			const maxleft = containerWidth - imageWidth;

			const currentTop = clientY - this.lastYAxisOfImage;
			const currentLeft = clientX - this.lastXAxisOfImage;

			// image width is smaller than container, only update top
			if (imageWidth < containerWidth) {

				this.fsImageContainer.style.top = `${clientY - this.lastYAxisOfImage}px`;

				if (currentTop > 0) {

					this.fsImageContainer.style.top = '0px';

				} else if (currentTop < maxtop) {

					this.fsImageContainer.style.top = `${maxtop}px`;

				}

				this.lastYAxisOfImage = clientY - this.fsImageContainer.offsetTop;

			} else if (imageHeight < containerHeight) {

				// image height is smaller than container, only update left

				this.fsImageContainer.style.left = `${clientX - this.lastXAxisOfImage}px`;

				if (currentLeft > 0) {

					this.fsImageContainer.style.left = '0px';

				} else if (currentLeft < maxleft) {

					this.fsImageContainer.style.left = `${maxleft}px`;

				}

				this.lastXAxisOfImage = clientX - this.fsImageContainer.offsetLeft;

			} else if (imageWidth > containerWidth && imageHeight > containerHeight) {

				// update all sides if image is bigger than content

				this.fsImageContainer.style.left = `${clientX - this.lastXAxisOfImage}px`;
				this.fsImageContainer.style.top = `${clientY - this.lastYAxisOfImage}px`;

				if (currentTop > 0) {

					this.fsImageContainer.style.top = '0px';

				} else if (currentTop < maxtop) {

					this.fsImageContainer.style.top = `${maxtop}px`;

				}

				if (currentLeft > 0) {

					this.fsImageContainer.style.left = '0px';

				} else if (currentLeft < maxleft) {

					this.fsImageContainer.style.left = `${maxleft}px`;

				}

				this.lastYAxisOfImage = clientY - this.fsImageContainer.offsetTop;
				this.lastXAxisOfImage = clientX - this.fsImageContainer.offsetLeft;

			}

		}

		clickImageHandler () {

			if (this.clickImage) {

				// zoom in
				if (this.isZoomingIn) {

					triggerEvent.call(this.fsZoomIn, 'click');

				} else if (!this.isZoomingIn) {

					// zoom out
					triggerEvent.call(this.fsZoomOut, 'click');

				}

			}

			return (this.isDragging = false);

		}

		fsZoomHandler (control) {

			switch (control.id) {

				case 'fsZoomIn':
					this.fsZoomInHandler();
					break;
				case 'fsZoomOut':
					this.fsZoomOutHandler();
					break;
				case 'fsReset':
					this.fsZoomResetHandler();
					break;
				default:
					// shouldn't ever get here.
					break;

			}

		}

		fsLoadHandler () {

			const { naturalWidth, naturalHeight } = this.largeImage;
			if (this.zoomCounter !== 1) {
				this.largeImage.removeAttribute('height');
				this.largeImage.removeAttribute('width');
			}

			if (!this.largeImageInitialHeight && !this.largeImageInitialWidth) {
				const heightRatio = this.contentHeight / naturalHeight;
				const widthRatio = this.contentWidth / naturalWidth;

				const decidingRatio = widthRatio < heightRatio ? widthRatio : heightRatio;

				const finalHeight = Math.floor(naturalHeight * decidingRatio);
				const finalWidth = Math.floor(naturalWidth * decidingRatio);
				this.largeImage.style.height = `${finalHeight}px`;
				this.largeImage.style.width = `${finalWidth}px`;
				this.largeImageInitialHeight = finalHeight;
				this.largeImageInitialWidth = finalWidth;
				this.centerImage(finalWidth, finalHeight, true);
			}
			this.imagesLoaded();
			this.fsLoader.classList.add('hidden');
			this.isZooming = false;

			this.largeImage.classList.remove('hidden');

		}

		getScaleConstant (currentImageHeight) {

			return (currentImageHeight + 300) / currentImageHeight;

		}

		imagesLoaded () {

			if (
				!this.originalImageWidth
				|| !this.originalImageHeight
				|| !this.largeImageInitialHeight
				|| !this.largeImageInitialWidth
			) {

				return;

			}

			const originalWidthDelta = this.originalImageWidth - this.largeImageInitialWidth;
			const originalHeightDelta = this.originalImageHeight - this.largeImageInitialHeight;
			this.scaleConstant = this.scaleConstant || this.getScaleConstant(this.largeImageInitialHeight);
			this.zoomCounterMax = Math.min(Math.floor(originalHeightDelta / 300), Math.floor(originalWidthDelta / 300));

			this.displayZoomControls();
			this.setImageDraggableStatus();

		}

		init () {

			this.setFullscreenElements();

			this.dragImageStartDelegate = (() => {

				const selector = `#${this.fsImageContainer.id}`;
				return delegateEvent(this.dragImageStartHandler, selector);

			})();

			this.moveImageDelegate = (() => {

				const selector = `#${this.fsImageContainer.id}`;

				return delegateEvent(this.moveImageHandler, selector);

			})();

			this.clickImageDelegate = (() => {

				const selector = `#${this.fsImageContainer.id}`;

				return delegateEvent(this.clickImageHandler, selector);

			})();

			this.zoomHandlerListener = (e) => {

				if (e.target.classList.contains('disabled')) {

					return;

				}

				e.preventDefault();
				this.fsZoomHandler(e.target);

			};

			this.fsNavHandlerListener = (e) => {
				const targetThumb = e.target.closest('.thumbnailWrapper');
				if (targetThumb) this.fsNavClickHandler(targetThumb);
			};

			this.initFsNav();

			if (this.hasModalVideos) {

				this.initVideoPlayer();

			}

			if (this.isVideo) {

				this.zoomCounter = 0;

			} else {

				this.displayFullImage(this.image);

			}
			this.initDragControls();
			this.initZoomControls();

		}

		videoDismissOnUnmount (error, trackingData) {

			this.hideImage();
			window.lp.video.activeVideoHeadline = '';
			fsVideoPlayer?.destroy();
			this.htmlVideoPlayer?.pause();
			this.fsVideoPlayerDiv = document.getElementById('fsVideoPlayer');
			if (this.hasModalVideos) {

				this.hideVideoPlayer();
				this.hideVideoContainer();

			}
			fsVideoPlayer = null;

			// in case of error return
			if (error) {

				console.error(error);
				return;

			}

			if (trackingData) {

				// otherwise track video dismiss
				sendVideoAnalytics(trackingData);

			}

		}

		onUnmount () {

			clearInterval(window.lp.videoPlaybackInterval);

			if (fsVideoPlayer) {

				trackVideoDismiss(fsVideoPlayer)
					.then((trackingData) => {

						this.videoDismissOnUnmount(null, trackingData);

					})
					.catch((err) => {

						this.videoDismissOnUnmount(err);

					});

			}

			// reset to original visibility state
			this.fsImageContainer.classList.add('hidden');
			this.fsVideoContainer.classList.add('hidden');

			this.fsContent.removeEventListener('mousedown', this.dragImageStartDelegate);
			this.fsContent.removeEventListener('touchstart', this.dragImageStartDelegate);

			this.fsContent.removeEventListener('mousemove', this.moveImageDelegate);
			this.fsContent.removeEventListener('touchmove', this.moveImageDelegate);

			this.fsContent.removeEventListener('mouseup', this.clickImageDelegate);
			this.fsContent.removeEventListener('mouseout', this.clickImageDelegate);

			const zoomControls = this.fsZoomOptions.querySelectorAll('.zoomControl');

			zoomControls.forEach((control) => {

				control.removeEventListener('click', this.zoomHandlerListener);

			});

			const fsNav = document.getElementById('fsNav');

			fsNav.removeEventListener('click', this.fsNavHandlerListener);

			const fsPhotoTitle =  document.querySelector(".fsPhotoTitle");
			if(fsPhotoTitle) fsPhotoTitle.innerHTML = "";

		}

	}

	window.lp.plugins = window.lp.plugins || {};
	window.lp.plugins.FullScreen = FullScreen;

})();
